var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnologyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dvr_24dp_5F6368_FILL1_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.25 24.5C12.7458 24.5 13.1615 24.3323 13.4969 23.9969C13.8323 23.6615 14 23.2458 14 22.75C14 22.2542 13.8323 21.8385 13.4969 21.5031C13.1615 21.1677 12.7458 21 12.25 21C11.7542 21 11.3385 21.1677 11.0031 21.5031C10.6677 21.8385 10.5 22.2542 10.5 22.75C10.5 23.2458 10.6677 23.6615 11.0031 23.9969C11.3385 24.3323 11.7542 24.5 12.25 24.5ZM12.25 17.5C12.7458 17.5 13.1615 17.3323 13.4969 16.9969C13.8323 16.6615 14 16.2458 14 15.75C14 15.2542 13.8323 14.8385 13.4969 14.5031C13.1615 14.1677 12.7458 14 12.25 14C11.7542 14 11.3385 14.1677 11.0031 14.5031C10.6677 14.8385 10.5 15.2542 10.5 15.75C10.5 16.2458 10.6677 16.6615 11.0031 16.9969C11.3385 17.3323 11.7542 17.5 12.25 17.5ZM15.75 24.5H31.5V21H15.75V24.5ZM15.75 17.5H31.5V14H15.75V17.5ZM14 36.75V33.25H7C6.0375 33.25 5.21354 32.9073 4.52812 32.2219C3.84271 31.5365 3.5 30.7125 3.5 29.75V8.75C3.5 7.7875 3.84271 6.96354 4.52812 6.27812C5.21354 5.59271 6.0375 5.25 7 5.25H35C35.9625 5.25 36.7865 5.59271 37.4719 6.27812C38.1573 6.96354 38.5 7.7875 38.5 8.75V29.75C38.5 30.7125 38.1573 31.5365 37.4719 32.2219C36.7865 32.9073 35.9625 33.25 35 33.25H28V36.75H14Z",
    fill: "#D9E8F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnologyicon);
export default __webpack_public_path__ + "static/media/technology+icon.c5fb243179edbcc7c65bb8c026ece40a.svg";
export { ForwardRef as ReactComponent };